var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Headertip',{attrs:{"tipContent":_vm.tipContent}}),_c('role-Item'),_c('createRole',{attrs:{"addRole":_vm.addRole}}),_c('member',{attrs:{"memberParams":_vm.memberParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }